import { useMemo } from 'react';
import { useOvermindState } from '#store/overmind';
import {
    Product,
} from '#types/generated/graphql-types';
import { RESORTPASS_PRODUCT_NAMES } from '#types/mackstorewallet';

const useResortPass = () => {
  const { extra } = useOvermindState().user;

  const hasResortPass = useMemo(() => {
      return extra?.wallets?.some(wallet =>
        wallet.mediums.some(medium =>
          medium.items.some(item =>
            RESORTPASS_PRODUCT_NAMES.includes(item.productName)
          )
      )
    ) ?? false;
  }, [extra?.wallets]);

  // Checks if a product has a wallet tariff name set to check for ResortPasses
  const isResortPassProduct = (product: Product | null | undefined): boolean => {
    if (!product?.walletTariffName) return false;

    const tariffName = product.walletTariffName.toLowerCase().trim();

    return RESORTPASS_PRODUCT_NAMES.includes(tariffName);
  };

  const resortPassWalletCount = useMemo(() => {
    if (!hasResortPass || !extra?.wallets) return 0;

    return extra.wallets.reduce((count, wallet) => {
      const hasResortPassItem = wallet.mediums.some(medium =>
        medium.items.some(item =>
          RESORTPASS_PRODUCT_NAMES.includes(item.productName)
        )
      );
      return count + Number(hasResortPassItem);
    }, 0);
  }, [hasResortPass, extra?.wallets]);

  return { hasResortPass, isResortPassProduct, resortPassWalletCount };
};

export default useResortPass;
